import { systemErrorCache } from '../context/appCache'
import { getErrorData, isGenericError } from './errorMapping'

const handleFindBillError = (error, setSystemError) => {
  if (error && isGenericError({ error })) {
    setSystemError(true)
  } else if (error) {
    const {
      message,
      fieldErrorData: { CTA },
      hasSystemError
    } = getErrorData({
      error,
      // : sessionStorage.errorcode ? errorMock : error,
      pageName: 'addEditErrors'
    })

    if (message !== '') {
      if (hasSystemError) {
        systemErrorCache({
          errorMsg: message,
          CTA,
          hasSystemError
        })
        setSystemError(true)
      }
    } else {
      setSystemError(true)
    }
  }
}

export default handleFindBillError
